// Override Settings 
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		defaultDisplay: bcSfFilterConfig.custom.layout,
		numberFilterTree: 2,
	}
};

// Declare Templates
var bcSfFilterTemplate = {
	// Grid Template
	'productGridItemHtml': '<div class="product-grid-item grid__item sm--{{itemPerRowMobile}} md--up--{{itemPerRowDesktop}} mt3 lg--up--mt4">' +
								'{{itemProductHtml}}' +
							'</div>',
	'productlistItemHtml': '<div class="item item--large-gap item--desktop--half item--mobile--full {{itemFirst}}  {{itemLast}}  {{itemFadeIn}}">' +
								'<div class="item__inner {{itemMobileClass}} {{itemDesktopClass}}">' +
									'{{itemProductHtml}}' +
								'</div>' +
							'</div>',
  
	'productItemHtml': '<a href="{{itemUrl}}" class="product-grid-item t--list-and-grid relative">' +
              '{{itemImages}}' +
              '<div class="product-details__container">'+
              '<div class="product-details__single>'+
							'<p class="color--{{itemSectionColor}}-text m0 mt2 {{itemBasicFontSize}}">{{itemTitle}}</p>' +
							'{{itemVendor}}' +
              '{{itemPrice}}' +
              '</div>'+
              '<div class="product-details__single">'+
              '<p style="margin-bottom: 0; text-align: right;">{{itemInventoryLeft}}</p>'+
              '<p style="text-align: right;">{{itemMade}}</p>'+
              '</div>'+
              '</div>'+
						'</a>',

	// Pagination Template
	'previousActiveHtml': '<a class="p1 pointer" href="{{itemUrl}}" title=""><span class="font-size--xxxxs inline-block align--top border-bottom--transparent hv--border-bottom--{{itemSectionColor}}-text"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 64 64"><path fill="#162317" fill-rule="evenodd" d="M23.324 32L44.66 53.337l-2.666 2.666L18 32.008l.008-.007-.008-.008L41.993 8l2.666 2.666-21.335 21.336z"/></svg></span></a>',
	'previousDisabledHtml': '',
	'nextActiveHtml': '<a class="p1 pointer" href="{{{{itemUrl}}}}" title=""><span class="font-size--xxxxs inline-block align--top border-bottom--transparent hv--border-bottom--{{itemSectionColor}}-text"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 64 64"><path fill="#162317" fill-rule="evenodd" d="M39.336 32L18 10.663l2.666-2.666L44.66 31.992l-.008.007.008.008L20.667 56 18 53.335l21.335-21.336z"/></svg></span></a>',
	'nextDisabledHtml': '',
	'pageItemHtml': '<a class="p1 pointer hv--span--border-bottom--{{itemSectionColor}}-text" href="{{itemUrl}}"><span class="border-bottom--transparent">{{itemTitle}}</span></a>',
	'pageItemSelectedHtml': '<a class="p1"><span class="border-bottom--{{itemSectionColor}}-text">{{itemTitle}}</span></a>',
	'pageItemRemainHtml': '<a class="p1 pointer" href="{{itemUrl}}"><span class="border-bottom--transparent">{{itemTitle}}</span></a>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
	// Sorting Template
	'sortingHtml': ' <label class="sm--hide '+ bcSfFilterConfig.custom.global__basic_font_size +' mr1" for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label> <select id="bc-sf-filter-top-sorting-select" class="bg--transparent border--'+ bcSfFilterConfig.custom.section_color +'-text color--'+ bcSfFilterConfig.custom.section_color +'-text p1 inline-block '+ bcSfFilterConfig.custom.global__basic_font_size +' pr3">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;
	itemHtml = itemHtml.replace(/{{itemProductHtml}}/g, buildProductHtml(data));

	var itemPerRowMobile = bcSfFilterConfig.custom.products_per_row_mobile;
	itemHtml = itemHtml.replace(/{{itemPerRowMobile}}/g, itemPerRowMobile);

	var itemPerRowDesktop = bcSfFilterConfig.custom.products_per_row_desktop;
	itemHtml = itemHtml.replace(/{{itemPerRowDesktop}}/g, itemPerRowDesktop);

	return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data, index) {
	var itemHtml = bcSfFilterTemplate.productlistItemHtml;
	itemHtml = itemHtml.replace(/{{itemProductHtml}}/g, buildProductHtml(data));

	var itemFirst = (index == 1) ? 'item--first' : '';
	itemHtml = itemHtml.replace(/{{itemFirst}}/g, itemFirst);

	var itemLast = (index == bcSfFilterConfig.custom.products_per_page) ? 'item--last' : '';
	itemHtml = itemHtml.replace(/{{itemLast}}/g, itemFirst);

	var itemFadeIn = (bcSfFilterConfig.custom.layout) ? 'fade-in' : '';
	itemHtml = itemHtml.replace(/{{itemFadeIn}}/g, itemFadeIn);

	var itemMobileClass = (index % 2 === 0) ? 'md--dn--pl4' : 'md--dn--pr4';
	itemHtml = itemHtml.replace(/{{itemMobileClass}}/g, itemMobileClass);

	var itemDesktopClass = (bcSfFilterConfig.custom.col_count_desktop == 1) ? '' : 'lg--up--five-sixths lg--up--mx--auto';
	itemHtml = itemHtml.replace(/{{itemDesktopClass}}/g, itemDesktopClass);

	return itemHtml;
};
function buildProductHtml(data) {
	/*** Prepare data ***/
	var images = data.images_info;
	//data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/
	var itemHtml = bcSfFilterTemplate.productItemHtml;
	// Add Thumbnail
	var itemImagesHtml = '';
	//images.length > 0 ? bcsffilter.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
	if (images.length > 0) {
		var aspect_ratio = images[0]['width'] / images[0]['height'];
		var force_crop = '';
		if (aspect_ratio < 0.5) {
			aspect_ratio = 1;
			force_crop = 'force-crop'
		}
		var max_height_image = images[0].height;
		var max_width_image = images[0].width;
		if (aspect_ratio <= 1) {
			max_height_image = Math.min(images[0].height, 2000);
			max_width_image = max_height_image * aspect_ratio;
		} else {
			max_width_image = Math.min(images[0].width, 2000);
			max_height_image = max_width_image / aspect_ratio;
		}
		itemImagesHtml += '<div class="relative">';
		itemImagesHtml += '{{itemLabels}}';
		itemImagesHtml += '<style>' +
			'#Image-' + images[0].id + ' {max-width: ' + max_width_image + 'px; max-height: ' + max_height_image + 'px;}' +
			'#ImageWrapper-' + images[0].id + ' {max-width: ' + max_width_image + 'px; padding-top:' + (1 / aspect_ratio * 100) + '%;}' +
			'</style>';
		itemImagesHtml += '<div id="ImageWrapper-' + images[0].id + '" data-image-id="' + images[0].id + '" class="responsive-image__wrapper ' + force_crop + '">';
		itemImagesHtml += '<img id="Image-' + images[0]['id'] + '" ' +
			'class="responsive-image__image lazyload" ' +
			'width="' + images[0]['width'] + '"' +
			'height="' + images[0]['height'] + '"' +
			'src="' + bcsffilter.getFeaturedImage(images, '600x') + '" ' +
			'data-src="' + bcsffilter.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 360, 470, 600, 750, 940, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-ratio="' + aspect_ratio + '"' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		if (images.length > 1 && bcSfFilterConfig.custom.products_show_second_image_on_hover) {
			itemImagesHtml += '<div class="product-item-hover absolute top--0 right--0 bottom--0 left--0 z1 lazyload bg-cover"' +
				' data-bgset="' + bgset(images[1]) + '"' +
				' data-sizes="auto"' +
				' data-parent-fit="cover"' +
				' style="background-image: url(' + bcsffilter.optimizeImage(images[1].src, '300x') + ');">' +
				'</div>';
		}
		itemImagesHtml += '</div>';
		itemImagesHtml += '<noscript><img src="' + bcsffilter.getFeaturedImage(images) + '" alt="" class="product__img"></noscript>';
		itemImagesHtml += '</div>';
	}
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add vendor
	var itemVendor = bcSfFilterConfig.custom.products_show_vendor ? '<p class="color--{{itemSectionColor}}-meta m0 {{itemBasicFontSize}}">' + data.vendor + '</p>' : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

	// Add Price
	var itemPriceHtml = '';
	if (data.price_min > 0) {
		itemPriceHtml += '<p class="';
		itemPriceHtml += (onSale) ? 'color--{{itemSectionColor}}-accent' : 'color--{{itemSectionColor}}-meta';
		itemPriceHtml += ' m0  {{itemBasicFontSize}}">';
		if (soldOut) {
			itemPriceHtml += '<span class="sold-out color--{{itemSectionColor}}-meta ';
			itemPriceHtml += (onSale) ? 'mr1' : '';
			itemPriceHtml += '">' + bcSfFilterConfig.label.sold_out + '</span>';
		} else {
			itemPriceHtml += '<span ';
			itemPriceHtml += (onSale) ? 'class="mr1" >' : '>';
			if (onSale) {
				if (priceVaries) {
					itemPriceHtml += (bcSfFilterConfig.label.from).replace(/{{ price }}/g, bcsffilter.formatMoney(data.price_min));
				} else {
					itemPriceHtml += bcsffilter.formatMoney(data.price_min);
				}
			} else {
				if (priceVaries) {
					itemPriceHtml += (bcSfFilterConfig.label.from).replace(/{{ price }}/g, bcsffilter.formatMoney(data.price_min));
				} else {
					itemPriceHtml += bcsffilter.formatMoney(data.price_min);
				}
			}
			itemPriceHtml += '</span>';
		}
		if (onSale && !soldOut) {
			itemPriceHtml += '<s class="color--{{itemSectionColor}}-meta">' + bcsffilter.formatMoney(data.compare_at_price_min) + '</s> ';
		}

		itemPriceHtml += '</p>';
	}
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add labels
	var itemLabels = '';
	if (bcSfFilterConfig.custom.products_show_badges) {
		if (onSale || soldOut) {
			itemLabels += '<div class="absolute top--0 right--0 pt2 pr2 z2">';
			if (soldOut) {
				itemLabels += '<div class="' + (onSale ? 'mt1' : '') + ' product-grid-on-sale p1 font-size--s bg--{{itemSectionColor}}-text color--{{itemSectionColor}}-text--overlay">' + bcSfFilterConfig.label.sold_out + '</div>';
			} else if (onSale) {
				itemLabels += '<div class="product-grid-on-sale p1 font-size--s bg--{{itemSectionColor}}-accent color--{{itemSectionColor}}-accent--overlay">' + bcSfFilterConfig.label.on_sale + '</div>';
			}
			itemLabels += '</div>';
		}
	}
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabels);

	var itemSectionColor = bcSfFilterConfig.custom.section_color;
	itemHtml = itemHtml.replace(/{{itemSectionColor}}/g, itemSectionColor);

	var itemBasicFontSize = bcSfFilterConfig.custom.global__basic_font_size;
	itemHtml = itemHtml.replace(/{{itemBasicFontSize}}/g, itemBasicFontSize);

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, bcsffilter.buildProductItemUrl(data));
  
  // 'Made' tag
  var showMadeLabel = bcSfFilterConfig.custom.products_show_made;
  if (showMadeLabel) {
    var productTags = data.tags;
    var madeText = '';
    var hasMadeTag = false;
    for (var i = 0; i < productTags.length; i++) {
      if (productTags[i].search('made:') > -1) {
        madeText = 'Only ' + productTags[i].split(':')[1] + ' made';
        hasMadeTag = true;
      }
    }

    if (hasMadeTag) {
      itemHtml = itemHtml.replace(/{{itemMade}}/g, madeText);
    } else {
      itemHtml = itemHtml.replace(/{{itemMade}}/g, '');
    }
  } else {
    itemHtml = itemHtml.replace(/{{itemMade}}/g, '');
  }

  // Product inventory notification
  var showInventory = bcSfFilterConfig.custom.show_inventory;
  if (showInventory) {
    var inventoryThreshold = parseInt(bcSfFilterConfig.custom.inventory_threshold);
    var inventoryProductTypes = bcSfFilterConfig.custom.inventory_product_types;

    var productVariants = data.variants;
    var totalInventory = 0;
    for (var i = 0; i < productVariants.length; i++) {
      totalInventory += productVariants[i].inventory_quantity;
    }

    if (inventoryProductTypes.length === 0) {
      if (totalInventory < inventoryThreshold && totalInventory > 5) {
        var inventoryNotification = 'Only ' + totalInventory + ' left';
        itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, inventoryNotification);
      } else if (totalInventory < 5 && totalInventory > 0) {
        var inventoryNotification = 'Last Sizes';
        itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, inventoryNotification);
      } else {
        itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, '');
      }
    } else {
      var productType = data.product_type;
      if (inventoryProductTypes.search(productType) > -1 || inventoryProductTypes.search(productType.toLowerCase()) > -1) {
        if (totalInventory < inventoryThreshold && totalInventory > 5) {
          var inventoryNotification = 'Only ' + totalInventory + ' left';
          itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, inventoryNotification);
        } else if (totalInventory < 5 && totalInventory > 0) {
          var inventoryNotification = 'Last Sizes';
          itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, inventoryNotification);
        } else {
          itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, '');
        }
      } else {
        itemHtml = itemHtml.replace(/{{itemInventoryLeft}}/g, '');
      }
    }
  }

	return itemHtml;
}

function bgset(image) {
	var bgset = '';
	if (image) {
		var aspect_ratio = image.width / image.height;

		if (image.width > 180) bgset += ' ' + bcsffilter.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
		if (image.width > 360) bgset += ' ' + bcsffilter.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
		if (image.width > 540) bgset += ' ' + bcsffilter.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
		if (image.width > 720) bgset += ' ' + bcsffilter.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
		if (image.width > 900) bgset += ' ' + bcsffilter.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
		if (image.width > 1080) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
		if (image.width > 1296) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
		if (image.width > 1512) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
		if (image.width > 1728) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
		if (image.width > 1950) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
		if (image.width > 2100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
		if (image.width > 2260) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
		if (image.width > 2450) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
		if (image.width > 2700) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
		if (image.width > 3000) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
		if (image.width > 3350) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
		if (image.width > 3750) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
		if (image.width > 4100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
		bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
	}
	return bgset;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	if (this.getSettingValue('general.paginationType') == 'default') {
		// Get page info
		var currentPage = parseInt(this.queryParams.page);
		var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage == 1) {
			jQ(this.selector.bottomPagination).html('');
			return false;
		}
		if (this.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = bcSfFilterTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			var itemSectionColor = bcSfFilterConfig.custom.section_color;
			paginationHtml = paginationHtml.replace(/{{itemSectionColor}}/g, itemSectionColor);

			jQ(this.selector.bottomPagination).html(paginationHtml);
		}
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');
		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content 
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);
			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);
//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

function productGridItems() {
  jQ(".product-grid-item").on({
    mouseenter: function mouseenter() {
      jQ(this).find('.product-item-hover ').addClass('show');
    },
    mouseleave: function mouseleave() {
      jQ(this).find('.product-item-hover ').removeClass('show');
    }
  });
}

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	jQ('.collection').find('#bc-sf-filter-products').find(".item").addClass("ready").removeClass('fade-in');
  
// 	if (jQ('.collection').data("fade-in") === true) {
// 		Boost_fadeIn('.collection');
// 	}
// 	if (window.theme && Boost_productGridItems) {
// 		Boost_productGridItems();
// 	}
  	productGridItems();
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) { };

BCSfFilter.prototype.buildProductListData = function (data, eventType) {

	if (this.getSettingValue('general.paginationType') == 'default' || (this.getSettingValue('general.paginationType') != 'default' && eventType != 'page')) {
		jQ(this.getSelector('products')).html('');
		jQ(window).unbind('scroll');
	}

	var itemsHtml = '';
  var totalProduct = data.length;

	if (this.queryParams.display == 'list') {
		itemsHtml = '<div class="item-sizer"></div><div class="column-sizer"></div>' + itemsHtml;
	}
	for (var i = 0; i < totalProduct; i++) {
		switch (this.queryParams.display) {
			case 'list': var itemHtml = this.buildProductListItem(data[i], i + 1, totalProduct); break;
			case 'collage': var itemHtml = this.buildProductCollageItem(data[i], i + 1, totalProduct); break;
			default: var itemHtml = this.buildProductGridItem(data[i], i + 1, totalProduct); break;
		}
		itemsHtml += this.buildProductItemAdvanced(data[i], itemHtml);
	}

	if (this.queryParams.display == 'list') {
		var $newMasonryContent = Boost_themejQ(itemsHtml);
		Boost_themejQ(this.getSelector('products')).append($newMasonryContent).masonry('prepended', $newMasonryContent);
	} else {
		Boost_themejQ(this.getSelector('products')).append(itemsHtml);
	}
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
